import React, { useEffect, useState } from 'react'
import api from './api'
import '../css/Login.css'
import md5 from 'js-md5'
import { LockOutlined } from '@ant-design/icons'
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { message, Result, Form, Input, Button } from 'antd'

import Logo from '../images/logo.png'


//  邮件验证布局
function Verify() {
    const id = useParams()
    // const navigate = useNavigate()
    const [data, setData] = useState({ forget_passwordID: false })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [search] = useSearchParams()

    //  跳转
    function loginAction() {
        var redirect = search.get("redirect") || "/"
        navigate(redirect, { replace: true })
    }

    useEffect(() => {
        let token = id.id
        const key = Date
        message.loading({ key, content: '验证中...', })

        api.post('/api/v2/user/forget_password_verify_token', {
            verify_token: token,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success({ key, content: '验证成功, 请在下方设置新的密码!' })
                    setData({ forget_passwordID: res.data.data.data.forget_passwordID })
                } else {
                    message.error({ key, content: res.data.data.text })
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }, [])

    //  提交登陆
    function onFinish(values) {
        setLoading(true)
        setTimeout(() => {
            api.post('/api/v2/user/forget_password_set', {
                forget_passwordID: data.forget_passwordID,
                password: md5(values.password),
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        message.success('已成功修改密码, 请登录!')
                        loginAction()
                    } else {
                        message.error(res.data.data.text)
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                    setLoading(false)
                })
        }, 500);
    }


    return (
        <div className='login forget_password'>
            <Result
                icon={<LoadingOutlined />}
                title="正在向服务器进行验证..."
                style={{ display: data.forget_passwordID ? 'none' : '' }}
            />


            <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                style={{ display: data.forget_passwordID ? '' : 'none' }}
            >
                <div className='logo'>
                    <Link to="/">
                        <img src={Logo} alt='logo'></img>
                    </Link>
                </div>

                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            type: 'password',
                            message: '请输入正确的新密码!',
                        },
                    ]}
                >
                    <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="新密码" />
                </Form.Item>

                <Form.Item>
                    <div id="demo"></div>
                    <Button type="primary" htmlType="submit" shape="round" className="login-form-button" loading={loading}>设置密码</Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default Verify;